import { render, staticRenderFns } from "./QueryTableProfilingComponent.vue?vue&type=template&id=038e3a06&lang=pug"
import script from "./QueryTableProfilingComponent.vue?vue&type=script&lang=js"
export * from "./QueryTableProfilingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038e3a06')) {
      api.createRecord('038e3a06', component.options)
    } else {
      api.reload('038e3a06', component.options)
    }
    module.hot.accept("./QueryTableProfilingComponent.vue?vue&type=template&id=038e3a06&lang=pug", function () {
      api.rerender('038e3a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality/components/QueryTableProfilingComponent.vue"
export default component.exports